/*
 * @Author: 刘小博
 * @Date: 2023-02-17 14:16:48
 * @LastEditTime: 2023-02-17 14:26:55
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\abutment-module\abutment-manage\modules\abutmentDisposeRouter.js
 * 对接处理
 */
const abutmentDisposeRouter = [
  // 对接模块 对接待处理数据
  {
    path: '/s2pDataApi/pending-data',
    name: 's2pDataApiPendingData',
    component: () =>
      import(
        /*webpackChunkName:"s2pDataApi" */
        '@/views/s2pDataApi/PendingData.vue'
        ),
    meta: {
      SecondaryMenu: '对接处理', //二级菜单
      title: '对接待处理数据',
    },
  },
  // 对接模块 对接待处理数据 处理结果
  {
    path: '/s2pDataApi/results',
    name: 's2pDataApiResults',
    component: () =>
      import(
        /*webpackChunkName:"s2pDataApi" */
        '@/views/s2pDataApi/Results.vue'
        ),
    meta: {
      SecondaryMenu: '对接处理', //二级菜单
      title: '处理结果',
      breadcrumb: [
        {
          title: '对接待处理数据',
          name: 's2pDataApiPendingData',
        },
      ],
    },
  },
  // 对接模块 对接待处理数据 处理结果2
  {
    path: '/s2pDataApi/results-detail/:date',
    name: 's2pDataApiResultsDetail',
    component: () =>
      import(
        /*webpackChunkName:"s2pDataApi" */
        '@/views/s2pDataApi/ResultsDetail.vue'
        ),
    meta: {
      SecondaryMenu: '对接处理', //二级菜单
      title: '处理结果详情',
      breadcrumb: [
        {
          title: '对接待处理数据',
          name: 's2pDataApiPendingData',
        },
        {
          title: '处理结果',
          name: 's2pDataApiResults',
        },
      ],
    },
  },
  // 对接模块 对接流向待处理数据
  {
    path: '/s2pDataApi/flow-pending-data',
    name: 's2pDataApiFlowPendingData',
    component: () =>
      import(
        /*webpackChunkName:"s2pDataApi" */
        '@/views/s2pDataApi/FlowPendingData.vue'
        ),
    meta: {
      SecondaryMenu: '对接处理', //二级菜单
      title: '流向对接待处理数据',
    },
  },
  // 对接模块 流向对接待处理数据 处理结果
  {
    path: '/s2pDataApi/flow-results',
    name: 's2pDataApiFlowResults',
    component: () =>
      import(
        /*webpackChunkName:"s2pDataApi" */
        '@/views/s2pDataApi/FlowResults.vue'
        ),
    meta: {
      SecondaryMenu: '对接处理', //二级菜单
      title: '处理结果',
      breadcrumb: [
        {
          title: '流向对接待处理数据',
          name: 's2pDataApiFlowPendingData',
        },
      ],
    },
  },

  // 对接模块 对接流向待处理数据 处理结果2
  /*
   *
   * type:6:销售数据  7:采购数据  8:库存数据
   * */
  {
    path: '/s2pDataApi/flow-results-detail/:date/:type',
    name: 's2pDataApiFlowResultsDetail',
    component: () => import('@/views/s2pDataApi/FlowResultsDetail.vue'),
    meta: {
      SecondaryMenu: '对接处理', //二级菜单
      title: '流向处理结果详情',
      breadcrumb: [
        {
          title: '流向对接待处理数据',
          name: 's2pDataApiFlowPendingData',
        },
        {
          title: '处理结果',
          name: 's2pDataApiFlowResults',
        },
      ],
    },
  },


  // 对接模块 api接口输出 调用记录 输出调用日志
  {
    path: '/s2pDataApi/logOfOutputCalled/page',
    name: 's2pDataApiLogOfOutputPage',
    component: () => import('@/views/s2pDataApi/apiInterfaceOutput/logOfCall/outputCallLog/Page.vue'),
    meta: {
      SecondaryMenu: '接口调用日志', //二级菜单
      title: '输出调用日志',
      // breadcrumb: [
      //   {
      //     title: '流向对接待处理数据',
      //     name: 's2pDataApiFlowPendingData',
      //   },
      //   {
      //     title: '处理结果',
      //     name: 's2pDataApiFlowResults',
      //   },
      // ],
    },
  },

  // 对接模块 输出日志 列表
  {
    path: '/s2pDataApi/logOfOut/page/:id',
    name: 's2pDataApiLogOfOutPage',
    component: () => import('@/views/s2pDataApi/apiInterfaceOutput/logOfOutput/Page.vue'),
    meta: {
      SecondaryMenu: '接口调用日志', //二级菜单
      title: '输出调用日志',
    },
  },

  // 对接模块 api接口输入 调用记录 输入调用日志
  {
    path: '/s2pDataApi/logOfInputCalled/page/:data_type',
    name: 's2pDataApiLogOfInputPage',
    component: () => import('@/views/s2pDataApi/apiInterfaceInput/logOfCall/Page.vue'),
    meta: {
      SecondaryMenu: '接口调用日志', //二级菜单
      title: '输入调用日志',
    },
  },
]

export default abutmentDisposeRouter
